import { render, staticRenderFns } from "./SchoolOrderModal.Style#Drawer.vue?vue&type=template&id=fedc1380&scoped=true"
import script from "./SchoolOrderModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./SchoolOrderModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./SchoolOrderModal.Style#Drawer.vue?vue&type=style&index=0&id=fedc1380&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc1380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fedc1380')) {
      api.createRecord('fedc1380', component.options)
    } else {
      api.reload('fedc1380', component.options)
    }
    module.hot.accept("./SchoolOrderModal.Style#Drawer.vue?vue&type=template&id=fedc1380&scoped=true", function () {
      api.rerender('fedc1380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolOrder/modules/SchoolOrderModal.Style#Drawer.vue"
export default component.exports